export default __webpack_public_path__ + "static/media/web.73abc43a.config";